module.exports = __webpack_public_path__ + "components/breakheader/static/surf-alert-be3c6edc754c5606ce32c1d7aede78b6.webp";